import * as React from 'react';

const DATA_ATTRIBUTE_INDEX = 'keyboard_index';

interface KeyNavigationProps {
  activeIndex: number;
  className?: string;
  onIndexChange: (index: number) => void;
  onKeyDown: (event: React.KeyboardEvent<Element>, key?: string) => void;
}

export class KeyNavigation extends React.PureComponent<
  React.PropsWithChildren<KeyNavigationProps>,
  {}
> {
  elementRef: any;

  componentDidMount() {
    this.setFocus();
  }

  componentDidUpdate(prevProps: KeyNavigationProps) {
    if (prevProps.activeIndex !== this.props.activeIndex) {
      this.setFocus();
    }
  }

  getChild(index: number) {
    return this.elementRef.querySelector(
      `[${DATA_ATTRIBUTE_INDEX}="${index}"]`
    );
  }

  setFocus() {
    const { activeIndex } = this.props;
    const child = this.getChild(activeIndex);

    if (child) {
      setTimeout(child.focus(), 10);
    }
  }

  renderChildren() {
    const { onKeyDown } = this.props;
    let keyIndex: number = -1;

    return React.Children.map(
      this.props.children,
      (child: any, index: number) => {
        if (!child.props.disabled) {
          keyIndex = keyIndex + 1;
        }
        return React.cloneElement(child, {
          key: child.key || index,
          [DATA_ATTRIBUTE_INDEX]: child.props.disabled ? '' : keyIndex,
          tabIndex: -1,
          onKeyDown: (event: React.KeyboardEvent) => {
            onKeyDown(event, child.key);
            if (child.props.onKeyDown) {
              child.props.onKeyDown(event);
            }
          },
        });
      }
    );
  }

  render() {
    const { className, onKeyDown } = this.props;

    return (
      <div
        className={className}
        onKeyDown={(e) => onKeyDown(e)}
        ref={(ref) => (this.elementRef = ref)}
        tabIndex={0}
      >
        {this.renderChildren()}
      </div>
    );
  }
}
